var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLinkRanking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 3.92308C6.75 3.41328 7.16328 3 7.67308 3H16.3269C16.8367 3 17.25 3.41328 17.25 3.92308V9.75C17.25 12.6495 14.8995 15 12 15C9.10051 15 6.75 12.6495 6.75 9.75V3.92308Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 3.92308C8.625 3.41328 9.0377 3 9.5475 3H16.3269C16.8367 3 17.25 3.41328 17.25 3.92308V9.75C17.25 12.6495 14.8995 15 12 15C10.9725 15 8.625 12.6495 8.625 9.75V3.92308Z",
    fill: "#F7DE2A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 3.92308C6.75 3.41328 7.16328 3 7.67308 3H16.3269C16.8367 3 17.25 3.41328 17.25 3.92308V9.75C17.25 12.6495 14.8995 15 12 15C9.10051 15 6.75 12.6495 6.75 9.75V3.92308Z",
    stroke: "#222222",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 7.125L12 6.375V10.125M10.875 10.125H13.125",
    stroke: "#222222"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 10.5C4.17525 10.5 3 9.32475 3 7.875C3 6.42525 4.17525 5.25 5.625 5.25",
    stroke: "#222222",
    strokeWidth: 1.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.375 10.5C19.8247 10.5 21 9.32475 21 7.875C21 6.42525 19.8247 5.25 18.375 5.25",
    stroke: "#222222",
    strokeWidth: 1.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15L12 18",
    stroke: "#222222",
    strokeWidth: 1.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 20.6087C7.5 19.168 8.66795 18 10.1087 18H13.8913C15.332 18 16.5 19.168 16.5 20.6087C16.5 20.8248 16.3248 21 16.1087 21H7.8913C7.67519 21 7.5 20.8248 7.5 20.6087Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkRanking);
export default __webpack_public_path__ + "static/media/icon_link_ranking.18c878ccf180623eb333c691a7175953.svg";
export { ForwardRef as ReactComponent };